<div class="loader_wrapper" *ngIf="show>0">
    <div class="loader"></div>
</div>